import styled from 'styled-components'

export const InformationContainer = styled.div`
  display: flex
  flex-direction: column
  gap: 16px
  padding: 20px
`

export const Section = styled.div`
  border: 1px solid #e5e7eb
  border-radius: 8px
  overflow: hidden
  background: white
`

export const SectionHeader = styled.div`
  display: flex
  justify-content: space-between
  align-items: center
  padding: 16px 20px
  background: #f9fafb
  border-bottom: 1px solid #e5e7eb
  cursor: pointer
  transition: background-color 0.2s ease

  &:hover {
    background: #f3f4f6
  }
`

export const SectionTitle = styled.h3`
  margin: 0
  font-size: 16px
  font-weight: 600
  color: #111827
`

export const SectionIcon = styled.span`
  font-size: 18px;
`

export const ChevronIcon = styled.span<{ $expanded: boolean }>`
  font-size: 12px
  color: #6b7280
  transition: transform 0.2s ease
  transform: ${(props) => (props.$expanded ? 'rotate(180deg)' : 'rotate(0deg)')}
`

export const SectionContent = styled.div`
  padding: 20px;
`

export const InfoGrid = styled.div`
  display: grid
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr))
  gap: 16px
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr
    gap: 12px
  }
`

export const InfoItem = styled.div`
  display: flex
  flex-direction: column
  gap: 4px
`

export const InfoLabel = styled.span`
  font-size: 12px
  font-weight: 500
  color: #6b7280
  text-transform: uppercase
  letter-spacing: 0.5px
`

export const InfoValue = styled.span`
  font-size: 14px
  font-weight: 500
  color: #111827
`

export const BuildingCard = styled.div`
  border: 1px solid #e5e7eb
  border-radius: 8px
  margin-bottom: 16px
  overflow: hidden

  &:last-child {
    margin-bottom: 0
  }
`

export const BuildingHeader = styled.div`
  padding: 16px
  background: #f9fafb
  border-bottom: 1px solid #e5e7eb
`

export const BuildingAddress = styled.h4`
  margin: 0 0 8px 0
  font-size: 15px
  font-weight: 600
  color: #111827
`

export const BuildingYear = styled.span`
  font-size: 13px
  color: #6b7280
`

export const ProtectedBadge = styled.span`
  font-size: 11px
  font-weight: 500
  color: #dc2626
  background: #fef2f2
  border: 1px solid #fecaca
  border-radius: 4px
  padding: 2px 6px
  text-transform: uppercase
  letter-spacing: 0.5px
`

export const BuildingDetails = styled.div`
  padding: 16px;
`

export const ZoneItem = styled.div`
  display: flex
  justify-content: space-between
  align-items: flex-start
  padding: 12px
  border: 1px solid #e5e7eb
  border-radius: 6px
  margin-bottom: 8px

  &:last-child {
    margin-bottom: 0
  }
`

export const ZoneName = styled.div`
  font-size: 14px
  font-weight: 500
  color: #111827
  margin-bottom: 2px
`

export const ZoneType = styled.div`
  font-size: 12px
  color: #6b7280
`

export const ZoneCoverage = styled.div`
  font-size: 14px
  font-weight: 600
  color: #059669
  background: #ecfdf5
  border-radius: 4px
  padding: 4px 8px
`

export const RestrictionItem = styled.div`
  border: 1px solid #e5e7eb
  border-radius: 6px
  margin-bottom: 12px
  overflow: hidden

  &:last-child {
    margin-bottom: 0
  }
`

export const RestrictionHeader = styled.div`
  display: flex
  justify-content: space-between
  align-items: center
  padding: 12px 16px
  background: #fef3f2
  border-bottom: 1px solid #e5e7eb
`

export const RestrictionName = styled.div`
  font-size: 14px
  font-weight: 500
  color: #111827
`

export const RestrictionStatus = styled.span<{
  $status: 'active' | 'inactive'
}>`
  font-size: 11px
  font-weight: 500
  text-transform: uppercase
  letter-spacing: 0.5px
  padding: 2px 6px
  border-radius: 4px
  
  ${(props) =>
    props.$status === 'active'
      ? `
    color: #dc2626
    background: #fef2f2
    border: 1px solid #fecaca
  `
      : `
    color: #6b7280
    background: #f9fafb
    border: 1px solid #e5e7eb
  `}
`

export const RestrictionDetails = styled.div`
  padding: 16px;
`

export const OwnerItem = styled.div`
  display: flex
  justify-content: space-between
  align-items: center
  padding: 12px
  border: 1px solid #e5e7eb
  border-radius: 6px
  margin-bottom: 8px

  &:last-child {
    margin-bottom: 0
  }
`

export const OwnerName = styled.div`
  font-size: 14px
  font-weight: 500
  color: #111827
  margin-bottom: 2px
`

export const OwnerType = styled.div`
  font-size: 12px
  color: #6b7280
  text-transform: capitalize
`

export const OwnerActions = styled.div`
  display: flex
  gap: 6px
`

export const ActionButton = styled.button`
  width: 28px
  height: 28px
  border: 1px solid #e5e7eb
  border-radius: 4px
  background: white
  color: #6b7280
  font-size: 11px
  font-weight: 600
  cursor: pointer
  transition: all 0.2s ease
  display: flex
  align-items: center
  justify-content: center

  &:hover {
    border-color: #3b82f6
    color: #3b82f6
    background: #eff6ff
  }
`

export const EmptyState = styled.div`
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  padding: 60px 20px
  text-align: center
`

export const EmptyIcon = styled.div`
  font-size: 48px
  margin-bottom: 16px
  opacity: 0.5
`

export const EmptyText = styled.div`
  font-size: 14px
  color: #6b7280
`
